import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { formatBytes } from "@air/utilities";
import { isPdfRenderedExtension } from "@air/utils-clips";
import classNames from "classnames";
import toUpper from "lodash/toUpper";
import pluralize from "pluralize";
import { memo } from "react";
export const AssetGalleryCardMetaDetails = /*#__PURE__*/ memo((param)=>{
    let { hasDarkBackground, clip, title, onTitleClick, onTitleCmdClick, width, titleTestId } = param;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pointer-events-none flex",
                style: {
                    width
                },
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    label: title,
                    side: "top",
                    sideOffset: 4,
                    children: /*#__PURE__*/ _jsx("button", {
                        "data-testid": titleTestId,
                        disabled: !onTitleClick,
                        onClick: (event)=>{
                            if ((event.metaKey || event.ctrlKey) && !!onTitleCmdClick) {
                                onTitleCmdClick === null || onTitleCmdClick === void 0 ? void 0 : onTitleCmdClick();
                            } else {
                                onTitleClick === null || onTitleClick === void 0 ? void 0 : onTitleClick();
                            }
                        },
                        className: classNames("pointer-events-auto truncate text-left font-medium hover:underline", hasDarkBackground ? "text-white" : "text-grey-12", !onTitleClick && "cursor-default"),
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                style: {
                    width
                },
                className: classNames("truncate text-12", hasDarkBackground ? "text-white" : "text-grey-11"),
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        "".concat(toUpper(clip.ext), " \xb7 ").concat(formatBytes(clip.size)),
                        !!clip.pages && /*#__PURE__*/ _jsxs("p", {
                            className: "inline-flex items-center",
                            children: [
                                "\xa0\xb7 ",
                                pluralize("page", clip.pages, true)
                            ]
                        }),
                        !isPdfRenderedExtension(clip.ext) && !!clip.width && !!clip.height && " \xb7 ".concat(clip.width, " x ").concat(clip.height)
                    ]
                })
            })
        ]
    });
});
AssetGalleryCardMetaDetails.displayName = "AssetGalleryCardMetaDetails";
